<template>
  <div class="search">
    <input v-model="query" class="input" ref="input" placeholder="Search" type="text" tabindex="0">
  </div>
</template>

<script>
export default {
  mounted() {
    this.$refs.input.focus()
  },
  computed: {
    query: {
      get() {
        return this.$store.state.query
      },
      set(val) {
        this.$store.commit('setQuery', val)
      }
    }
  }
}
</script>